import { render, staticRenderFns } from "./FullScreenCompont.vue?vue&type=template&id=35c03854&scoped=true&"
import script from "./FullScreenCompont.vue?vue&type=script&lang=js&"
export * from "./FullScreenCompont.vue?vue&type=script&lang=js&"
import style0 from "./FullScreenCompont.vue?vue&type=style&index=0&id=35c03854&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c03854",
  null
  
)

export default component.exports